import React from 'react';
import { Helmet } from 'react-helmet';
import brand from '../../../utils/brand';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import ResetForm from '../../../components/Forms/ResetForm';
import styles from './../../../components/Forms/user-jss';

//Services 
import { checkHasSession } from './../../../services/cognito_service'; 
class ResetPassword extends React.Component {

  constructor(props){
    super(props); 
    checkHasSession(); 
  }

  /*UNSAFE_componentWillMount(){
    checkHasSession(); 
  }*/

  render() {
    const title = brand.name + ' - Cambiar Contraseña';
    const description = brand.desc;
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <Helmet>
          <title>{title}</title>
          <meta name="description" content={description} />
          <meta property="og:title" content={title} />
          <meta property="og:description" content={description} />
          <meta property="twitter:title" content={title} />
          <meta property="twitter:description" content={description} />
        </Helmet>
        <div className={classes.container}>
          <Grid container spacing={24} alignItems="center" direction="row" justify="center">
            <Grid item md={6} xs={11}>
              {/* ----------------------------------------------------------------------*/}
              {/* Load Login Form */}
              <ResetForm/>
            </Grid>
          </Grid>
        </div>
      </div>
    );
  }
}

ResetPassword.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ResetPassword);
